export const Cookie = {
  i18n: 'i18next',
  session: 'dtc_session',
  idToken: 'dtc_id_token',
  refreshToken: 'dtc_refresh_token',
  currentQr: 'dtc_qr_hash',
} as const;

export const ERROR_MESSAGE = {
  UPDATE_USER_LANGUAGE: 'UPDATE_USER_LANGUAGE_ERROR',
  ONETRUST_TERMS: 'ONETRUST_TERMS_ERROR',
  ONETRUST_PRIVACY: 'ONETRUST_PRIVACY_ERROR',
  LOGIN_USER: 'LOGIN_USER_ERROR',
  OTP_VERIFY: 'OTP_VERIFY_ERROR',
  COMPLETE_CAMPAIGN_ACTION: 'COMPLETE_CAMPAIGN_ACTION_ERROR',
  SUBMIT_PRIZE_FORM: 'SUBMIT_PRIZE_FORM_ERROR',
  RECAPTCHA: 'RECAPTCHA_ERROR',
  CARD_COLLECTION_ALREADY_COMPLETED: 'CARD_COLLECTION_ALREADY_COMPLETED',
  CAMPAIGN_ACTIONS_NOT_COMPLETED: 'CAMPAIGN_ACTIONS_NOT_COMPLETED',
  GOOGLE_MAPS_LOAD_FAILED: 'GOOGLE_MAPS_LOAD_FAILED',
  SUBMIT_PHOTO: 'SUBMIT_PHOTO_ERROR',
  SUBMIT_FINISH_REGISTRATION: 'SUBMIT_FINISH_REGISTRATION_ERROR',
  SUBMIT_FINISH_REGISTRATION_CONFLICT: 'SUBMIT_FINISH_REGISTRATION_CONFLICT',
  BG_IMAGE_LOAD_FAILED: 'BG_IMAGE_LOAD_FAILED',
  GENERATE_PITCH: 'GENERATE_PITCH_ERROR',
} as const;
